module.exports = __webpack_public_path__ + "static/hero-f48661b540137ce41fb845c2cafa258e.mp4";